import { setStoryPools } from 'actions/default';
import toggleNotification from 'actions/notifications';
import { fetchStoryPools } from 'actions/storyPools';
import { Action, Resource, useWithPermissions } from 'components/Authorization';
import ContentBox from 'components/ContentBox';
import ContentBoxItem from 'components/ContentBoxItem';
import Search from 'components/Search';
import TitleWrapper from 'components/TitleWrapper';
import i18n from 'i18n';
import StoryPoolList from 'pages/story-pools/components/List';
import { FunctionComponent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

const NewsPoolContainer: FunctionComponent = () => {
  const navigate = useNavigate();
  const [storyPools, setStoryPoolsState] = useState<$Lns.StoryPool[]>([]);
  const [storyPoolsOrig, setStoryPoolsOrig] = useState<$Lns.StoryPool[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchSetStoryPools = () => {
      fetchStoryPools()
        .then(({ data }) => {
          dispatch(setStoryPools(data));
          setStoryPoolsState(data);
          setStoryPoolsOrig(data);
        })
        .catch(() =>
          dispatch(
            toggleNotification('Failed to load publish folders', 'error')
          )
        );
    };

    fetchSetStoryPools();
  }, [dispatch]);

  const onEdit = (storyPool: $Lns.StoryPool) => {
    navigate(`/story-pools/${storyPool.guid}/edit`);
  };

  const onRowClick = useWithPermissions(
    (storyPool: { guid: { value: string }; name: { value: string } }) => {
      const {
        guid: { value: guidValue }
      } = storyPool;
      navigate(`/story-pools/${guidValue}`);
    },
    Resource.STORY_POOL,
    Action.READ
  );

  return (
    <ContentBox>
      <ContentBoxItem title>
        <TitleWrapper title={i18n.t('links.sidebar.storyPools')} />
        <Search
          fields={storyPoolsOrig}
          searchKeys={['guid', 'name']}
          filterFields={setStoryPoolsState}
        />
      </ContentBoxItem>

      <StoryPoolList
        storyPools={storyPools}
        onEdit={onEdit}
        onRowClick={onRowClick}
      />
    </ContentBox>
  );
};

export default NewsPoolContainer;
